module.exports = __webpack_public_path__ + "img/login-fb.45b86382.jpg";